const FILE_UPLOAD_ENTITIES = {
  PRIMARY_TEXT: "Primary Text",
  SECONDARY_TEXT: "Secondary Text",
  NEGATIVE_TEXT: "Negative Text",
  BENCHMARK_SKILLS: "Benchmark Skills",
  BENCHMARK_MICROSKILLS: "Benchmark MicroSkills",
  BENCHMARK_JFA: "Benchmark JFA"
};

export default FILE_UPLOAD_ENTITIES;
